import React, {useEffect, useState} from "react";
import {useGlobal} from "../../Store";
import {Link} from "react-router-dom";
import styled from "styled-components";
import {postData} from "../../Utils/Server";
import Endpoints from "../../Constants/Endpoints";
import {useHistory} from "react-router-dom";
import {ERROR, Notify, SUCCESS} from "../../Utils/Notify";
import {updateDocumentTitle} from "../../Utils/Common";
import Map from "../Map/Map";
import {ReasonCaptureModal} from "../Common/ReasonCaptureModal";
import PageLayout from "../Layout/PageLayout";
import {Button, Card, CardTitleBar, CardBody, FormField, TextInput, StatusBadge, Spinner} from "../UI";
import {tokens} from "../../theme/tokens";

const InfoTable = styled.table`
    width: 100%;
    border-collapse: collapse;
    td {
        padding: ${tokens.spacing[3]} ${tokens.spacing[4]};
        font-size: ${tokens.typography.size.base};
        border-bottom: 1px solid ${tokens.colors.divider};
        vertical-align: middle;
    }
    td:first-child { color: ${tokens.colors.muted}; width: 45%; }
    td:last-child { color: ${tokens.colors.heading}; font-weight: ${tokens.typography.weight.semibold}; }
    tr:last-child td { border-bottom: 0; }
`;

const RegionDetails = props => {
    let history = useHistory();
    const [globalState, globalActions] = useGlobal();
    const [isLoading, setIsLoading] = useState(false);
    const [item, setItem] = useState({title: ''});
    const [pendingAction, setPendingAction] = useState(null);
    const [pendingUpdateEvent, setPendingUpdateEvent] = useState(null);
    const [mapCentre, setMapCentre] = useState({});
    const [name, setName] = useState('');
    const [centreLat, setCentreLat] = useState(0);
    const [centreLng, setCentreLng] = useState(0);
    const [radius, setRadius] = useState(10);

    const {id} = props.match.params;

    const load = () => {
        let data = new FormData();
        data.append("id", id);

        setIsLoading(true);
        postData(Endpoints.REGION_DETAIL, data)
            .then(res => res.json())
            .then(res => {
                setIsLoading(false);
                if (res.success === 1) {
                    setItem(res.data);
                    setName(res.data.title);
                    setRadius(res.data.radius);
                    setCentreLat(res.data.centre_lat);
                    setCentreLng(res.data.centre_lng);
                    setMapCentre({
                        lat: res.data.centre_lat,
                        lng: res.data.centre_lng
                    })
                    updateDocumentTitle(res.data.title)
                }
            })
            .catch((error) => {
                setIsLoading(false);
                console.log(error)
            });
    };

    useEffect(() => {
        load()
    }, []);

    function updateStatus(number, reason) {
        let data = new FormData();
        data.append("id", id);
        data.append("status", number);
        data.append("reason", reason);

        setIsLoading(true);
        postData(Endpoints.REGION_UPDATE_STATUS, data)
            .then(res => res.json())
            .then(res => {
                setIsLoading(false);
                Notify(res.message, res.success === 1 ? SUCCESS : ERROR);
                if (res.success === 1) {
                    load()
                }
            })
            .catch((error) => {
                setIsLoading(false);
                console.log(error)
            });
    }

    function updateDetails(e, reason) {
        if (e) e.preventDefault()

        let data = new FormData();
        data.append("id", id)
        data.append("name", name)
        data.append("centre_lat", centreLat)
        data.append("centre_lng", centreLng)
        data.append("radius", radius)
        data.append("reason", reason)

        setIsLoading(true)
        postData(Endpoints.REGION_UPDATE_DETAILS, data)
            .then(res => res.json())
            .then(res => {
                setIsLoading(false);
                Notify(res.message, res.success === 1 ? SUCCESS : ERROR);
                if (res.success === 1) {
                    load()
                }
            })
            .catch((error) => {
                setIsLoading(false);
                console.log(error)
            });
    }


    return (
        <PageLayout
            title={item.title}
            actions={item.title !== '' ? (
                <div style={{display: "flex", alignItems: "center", gap: tokens.spacing[2]}}>
                    {isLoading && <Spinner size={18}/>}
                    {!isLoading &&
                    <Button
                        variant={item.status === 1 ? "danger" : "primary"}
                        onClick={e => setPendingAction(item.status === 1 ? 0 : 1)}>
                        {item.status === 1 ? "Deactivate" : "Activate"}
                    </Button>
                    }
                    <Link to={"/areas/" + item.area_id}>
                        <Button variant="outline">Back to area details</Button>
                    </Link>
                </div>
            ) : null}
        >
            {item.title !== '' &&
            <div className="row">
                <div className="col-md-6">
                    <Card padded style={{marginBottom: tokens.spacing[4]}}>
                        <InfoTable>
                            <tbody>
                            <tr>
                                <td>Name</td>
                                <td>{item.title}</td>
                            </tr>
                            <tr>
                                <td>Centre lat</td>
                                <td>{item.centre_lat}</td>
                            </tr>
                            <tr>
                                <td>Centre lng</td>
                                <td>{item.centre_lng}</td>
                            </tr>
                            <tr>
                                <td>Radius in KM</td>
                                <td>{item.radius}</td>
                            </tr>
                            <tr>
                                <td>Status</td>
                                <td>
                                    <StatusBadge tone={item.status === 0 ? "neutral" : "success"}>
                                        {item.status === 0 ? "INACTIVE" : "ACTIVE"}
                                    </StatusBadge>
                                </td>
                            </tr>
                            </tbody>
                        </InfoTable>
                    </Card>

                    <Map showCircle={true} mapCentre={mapCentre} radius={item.radius}/>

                </div>
                <div className="col-md-6">
                    <Card padded={false}>
                        <CardTitleBar title="Update region"/>
                        <CardBody>
                            <form onSubmit={e => { e.preventDefault(); setPendingUpdateEvent(true); }}>

                                <FormField label="Name" required htmlFor="regionName">
                                    <TextInput id="regionName"
                                               type="text"
                                               required={true}
                                               placeholder="Name"
                                               value={name}
                                               onChange={e => setName(e.target.value)}
                                    />
                                </FormField>

                                <FormField label="Centre latitude" required htmlFor="regionLat">
                                    <TextInput id="regionLat"
                                               type="text"
                                               required={true}
                                               placeholder="Centre latitude"
                                               value={centreLat}
                                               onChange={e => setCentreLat(e.target.value)}
                                    />
                                </FormField>

                                <FormField label="Centre longitude" required htmlFor="regionLng">
                                    <TextInput id="regionLng"
                                               type="text"
                                               required={true}
                                               placeholder="Centre longitude"
                                               value={centreLng}
                                               onChange={e => setCentreLng(e.target.value)}
                                    />
                                </FormField>

                                <FormField label="Radius in KM" required htmlFor="regionRadius">
                                    <TextInput id="regionRadius"
                                               type="text"
                                               required={true}
                                               placeholder="Radius"
                                               value={radius}
                                               onChange={e => setRadius(e.target.value)}
                                    />
                                </FormField>

                                <Button type="submit" loading={isLoading}>Update</Button>

                            </form>
                        </CardBody>
                    </Card>
                </div>
            </div>
            }
            {pendingAction !== null &&
            <ReasonCaptureModal
                title={pendingAction === 0 ? "Deactivate region" : "Activate region"}
                onCancel={() => setPendingAction(null)}
                onConfirm={reason => { updateStatus(pendingAction, reason); setPendingAction(null); }}
            />
            }
            {pendingUpdateEvent &&
            <ReasonCaptureModal
                title="Update region details"
                onCancel={() => setPendingUpdateEvent(null)}
                onConfirm={reason => { updateDetails(null, reason); setPendingUpdateEvent(null); }}
            />
            }
        </PageLayout>
    )
};


export default RegionDetails
